module.exports = __webpack_public_path__ + "img/meituanyouxuan.eb6f0118.png";